// Branded Text Video Play on View (Smooth Version)
(function() {

    function initBrandedTextVideo() {

        const sections = document.querySelectorAll('.branded-text');
        if (!sections.length) {return;}

        sections.forEach(function(section) {

            const video = section.querySelector('video');
            if (!video) {return;}

            const observer = new IntersectionObserver(function(entries, observer) {

                entries.forEach(function(entry) {

                    if (entry.isIntersecting) {

                        if (video.readyState >= 2) {
                            video.play().catch(() => {});
                        } else {
                            video.addEventListener('canplay', function() {
                                video.play().catch(() => {});
                            }, { once: true });
                        }

                        // stop observing after first play
                        observer.unobserve(entry.target);
                    }

                });

            }, {
                root: null,
                threshold: 0.5,
            });

            observer.observe(section);

        });

    }

    document.addEventListener('DOMContentLoaded', initBrandedTextVideo);

})();